export default __webpack_public_path__ + "static/media/img15.45c401bc.svg";